(() => {
  const roots = document.querySelectorAll('[data-accessory-catalog]');
  roots.forEach((root) => {
    const rows = Array.from(root.querySelectorAll('[data-accessory-row]'));
    const categoryButtons = Array.from(root.querySelectorAll('[data-accessory-type-filter]'));
    const profileFilter = root.querySelector('[data-profile-filter]');
    const profileChips = root.querySelector('[data-profile-chips]');
    const resultCount = root.querySelector('[data-accessory-result-count]');
    const activeFilters = root.querySelector('[data-accessory-active-filters]');
    const activeFilterCount = root.querySelector('[data-active-filter-count]');
    const list = root.querySelector('[data-accessory-list]');
    const sortSelect = root.querySelector('[data-accessory-sort]');
    const clearButton = root.querySelector('[data-accessory-clear]');
    const noResults = root.querySelector('[data-accessory-no-results]');
    const pagination = root.querySelector('[data-accessory-pagination]');
    const pageStatus = root.querySelector('[data-page-status]');
    const pagePrevious = root.querySelector('[data-page-previous]');
    const pageNext = root.querySelector('[data-page-next]');
    const pageSize = Number(root.dataset.pageSize) || 12;
    const locale = document.documentElement.lang || 'de';
    const formatter = new Intl.NumberFormat(locale);
    const unknownLabel = root.dataset.labelUnknown || '';
    const limitedLabel = root.dataset.labelLimited || '';
    const resultLabel = root.dataset.labelResults || '';
    const pageLabel = root.dataset.labelPage || '';
    const allLabel = root.dataset.labelAll || '';
    const profileAllLabel = root.dataset.labelProfileAll || allLabel;
    const typePrefix = root.dataset.labelTypePrefix || '';
    const profilePrefix = root.dataset.labelProfilePrefix || '';
    let selectedType = new URL(location.href).searchParams.get('av_type') || 'all';
    let selectedProfiles = new Set();
    let currentPage = Math.max(1, Number(new URL(location.href).searchParams.get('av_page')) || 1);
    let sortedRows = rows;

    const profileRecord = (key) => {
      const [width, height] = key.split('x');
      return { key, label: `${width} × ${height} mm`, limited: false };
    };

    const supportedProfiles = new Set(['20x20', '40x20', '30x30', '60x30', '40x40', '80x40']);
    const parseProfileValues = (value) => (value || '').split('|').flatMap((label) => {
      const match = label.match(/(\d{2,3})\s*[×x]\s*(\d{2,3})/i);
      if (!match) return [];
      const key = `${Number(match[1])}x${Number(match[2])}`;
      return supportedProfiles.has(key) ? [profileRecord(key)] : [];
    });

    const extractProfiles = (row) => {
      const found = new Map();
      parseProfileValues(row.dataset.profileFit).forEach((profile) => found.set(profile.key, profile));
      parseProfileValues(row.dataset.profileFitLimited).forEach((profile) =>
        found.set(profile.key, { ...profile, limited: true })
      );
      return Array.from(found.values());
    };

    rows.forEach((row) => {
      const isSystemProfileAccessory = ['zubehor-systemprofile', 'zubehor-systemprofil-nut-6'].includes(root.dataset.collectionHandle);
      const profiles = isSystemProfileAccessory ? extractProfiles(row) : [];
      row._profiles = profiles;
      const tagContainer = row.querySelector('[data-profile-tags]');
      if (!tagContainer) return;
      if (isSystemProfileAccessory) {
        if (profiles.length) {
          profiles.forEach((profile) => {
            const tag = document.createElement('span');
            tag.className = `accessory-row__profile-tag${profile.limited ? ' accessory-row__profile-tag--limited' : ''}`;
            tag.textContent = `${profile.label}${profile.limited ? ` · ${limitedLabel}` : ''}`;
            tagContainer.append(tag);
          });
        } else {
          const tag = document.createElement('span');
          tag.className = 'accessory-row__profile-tag accessory-row__profile-tag--unknown';
          tag.textContent = unknownLabel;
          tagContainer.append(tag);
        }
        tagContainer.hidden = false;
      }
    });

    const allProfiles = new Map();
    rows.forEach((row) => (row._profiles || []).forEach((profile) => allProfiles.set(profile.key, profile.label)));
    const typeValues = new Set(['all', ...categoryButtons.map((button) => button.dataset.accessoryTypeFilter)]);
    if (!typeValues.has(selectedType)) selectedType = 'all';
    new URL(location.href).searchParams.getAll('av_profile').forEach((key) => {
      if (allProfiles.has(key)) selectedProfiles.add(key);
    });
    if (profileFilter && profileChips && allProfiles.size) {
      profileFilter.hidden = false;
      const allButton = document.createElement('button');
      allButton.type = 'button';
      allButton.className = 'accessory-catalog__chip is-active';
      allButton.dataset.profileAll = '';
      allButton.setAttribute('aria-pressed', 'true');
      allButton.textContent = profileAllLabel;
      profileChips.append(allButton);
      const profileOrder = ['30x30', '60x30', '40x40', '80x40'];
      const orderedProfiles = [...allProfiles.entries()].sort(([a], [b]) => {
        const aIndex = profileOrder.indexOf(a);
        const bIndex = profileOrder.indexOf(b);
        return (aIndex < 0 ? profileOrder.length : aIndex) - (bIndex < 0 ? profileOrder.length : bIndex) || a.localeCompare(b);
      });
      orderedProfiles.forEach(([key, label]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `accessory-catalog__chip${key === '40x40' ? ' accessory-catalog__chip--group-start' : ''}`;
        button.dataset.profileValue = key;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = label;
        const count = document.createElement('span');
        count.dataset.profileCount = key;
        button.append(count);
        profileChips.append(button);
      });
    }

    const matchesProfile = (row) => {
      if (!selectedProfiles.size) return true;
      const profiles = row._profiles || [];
      return !profiles.length || profiles.some((profile) => selectedProfiles.has(profile.key));
    };

    const selectedRows = () => sortedRows.filter((row) =>
      (selectedType === 'all' || row.dataset.accessoryType === selectedType) && matchesProfile(row)
    );

    const syncURL = (method = 'pushState') => {
      const url = new URL(location.href);
      ['av_type', 'av_profile', 'av_sort', 'av_page', 'page'].forEach((key) => url.searchParams.delete(key));
      if (selectedType !== 'all') url.searchParams.set('av_type', selectedType);
      selectedProfiles.forEach((key) => url.searchParams.append('av_profile', key));
      if (sortSelect?.value) url.searchParams.set('av_sort', sortSelect.value);
      if (currentPage > 1) url.searchParams.set('av_page', String(currentPage));
      history[method]({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const restoreURL = () => {
      const params = new URL(location.href).searchParams;
      selectedType = typeValues.has(params.get('av_type')) ? params.get('av_type') || 'all' : 'all';
      selectedProfiles = new Set(params.getAll('av_profile').filter((key) => allProfiles.has(key)));
      if (sortSelect) sortSelect.value = params.get('av_sort') || '';
      currentPage = Math.max(1, Number(params.get('av_page')) || 1);
      update();
    };

    const sortRows = () => {
      if (!list || !sortSelect) return;
      const mode = sortSelect.value;
      const sorted = [...rows].sort((a, b) => {
        if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (mode === 'title-descending') return b.dataset.productTitle.localeCompare(a.dataset.productTitle, locale, { sensitivity: 'base' });
        if (mode === 'title-ascending') return a.dataset.productTitle.localeCompare(b.dataset.productTitle, locale, { sensitivity: 'base' });
        return rows.indexOf(a) - rows.indexOf(b);
      });
      sortedRows = sorted;
      sorted.forEach((row) => list.append(row));
    };

    const update = () => {
      sortRows();
      const visible = selectedRows();
      const pageCount = Math.max(1, Math.ceil(visible.length / pageSize));
      currentPage = Math.min(currentPage, pageCount);
      const pageStart = (currentPage - 1) * pageSize;
      const pageRows = new Set(visible.slice(pageStart, pageStart + pageSize));
      rows.forEach((row) => { row.hidden = !pageRows.has(row); });

      if (resultCount) resultCount.textContent = `${formatter.format(visible.length)} ${resultLabel}`;
      if (noResults) noResults.hidden = visible.length > 0;
      if (pagination) {
        pagination.hidden = visible.length <= pageSize;
        pagePrevious.disabled = currentPage <= 1;
        pageNext.disabled = currentPage >= pageCount;
        pageStatus.textContent = `${pageLabel} ${currentPage} / ${pageCount}`;
      }
      if (clearButton) clearButton.hidden = selectedType === 'all' && selectedProfiles.size === 0;

      const activeCount = (selectedType !== 'all' ? 1 : 0) + (selectedProfiles.size ? 1 : 0);
      if (activeFilterCount) {
        activeFilterCount.textContent = activeCount ? `(${activeCount})` : '';
        activeFilterCount.hidden = activeCount === 0;
      }
      if (activeFilters) {
        activeFilters.replaceChildren();
        if (selectedType !== 'all') {
          const selectedButton = categoryButtons.find((button) => button.dataset.accessoryTypeFilter === selectedType);
          if (selectedButton) {
            const tag = document.createElement('span');
            tag.className = 'accessory-catalog__active-filter';
            tag.textContent = `${typePrefix}: ${selectedButton.dataset.filterLabel || selectedButton.textContent.trim()}`;
            activeFilters.append(tag);
          }
        }
        [...selectedProfiles].forEach((key) => {
          const tag = document.createElement('span');
          tag.className = 'accessory-catalog__active-filter';
          tag.textContent = `${profilePrefix}: ${allProfiles.get(key) || key}`;
          activeFilters.append(tag);
        });
      }

      categoryButtons.forEach((button) => {
        const key = button.dataset.accessoryTypeFilter;
        const countNode = button.querySelector('[data-filter-count]');
        const count = rows.filter((row) =>
          (key === 'all' || row.dataset.accessoryType === key) && matchesProfile(row)
        ).length;
        if (countNode) countNode.textContent = formatter.format(count);
        const active = selectedType === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (profileChips) {
        const allButton = profileChips.querySelector('[data-profile-all]');
        if (allButton) {
          const active = selectedProfiles.size === 0;
          allButton.classList.toggle('is-active', active);
          allButton.setAttribute('aria-pressed', String(active));
        }
        profileChips.querySelectorAll('[data-profile-value]').forEach((button) => {
          const key = button.dataset.profileValue;
          const active = selectedProfiles.has(key);
          const count = rows.filter((row) =>
            (selectedType === 'all' || row.dataset.accessoryType === selectedType) &&
            (!(row._profiles || []).length || (row._profiles || []).some((profile) => profile.key === key))
          ).length;
          const countNode = button.querySelector('[data-profile-count]');
          if (countNode) countNode.textContent = formatter.format(count);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
    };

    categoryButtons.forEach((button) => button.addEventListener('click', () => {
      selectedType = button.dataset.accessoryTypeFilter;
      currentPage = 1;
      syncURL();
      update();
    }));

    if (profileChips) profileChips.addEventListener('click', (event) => {
      const allButton = event.target.closest('[data-profile-all]');
      const profileButton = event.target.closest('[data-profile-value]');
      if (allButton) selectedProfiles.clear();
      if (profileButton) {
        const key = profileButton.dataset.profileValue;
        if (selectedProfiles.has(key)) selectedProfiles.delete(key);
        else selectedProfiles.add(key);
      }
      currentPage = 1;
      syncURL();
      update();
    });

    if (clearButton) clearButton.addEventListener('click', () => {
      selectedType = 'all';
      selectedProfiles.clear();
      currentPage = 1;
      if (sortSelect) sortSelect.value = '';
      syncURL();
      update();
    });

    if (sortSelect) sortSelect.addEventListener('change', () => { currentPage = 1; syncURL(); update(); });
    window.addEventListener('popstate', restoreURL);

    if (pagePrevious) pagePrevious.addEventListener('click', () => {
      currentPage = Math.max(1, currentPage - 1);
      syncURL();
      update();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (pageNext) pageNext.addEventListener('click', () => {
      currentPage += 1;
      syncURL();
      update();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      const input = button.closest('.accessory-row__quantity')?.querySelector('input[name="quantity"]');
      if (!input) return;
      const delta = Number(button.dataset.quantityChange) || 0;
      input.value = String(Math.max(1, (Number(input.value) || 1) + delta));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    const initialSort = new URL(location.href).searchParams.get('av_sort');
    if (sortSelect && initialSort) sortSelect.value = initialSort;
    const filterDisclosure = root.querySelector('[data-accessory-filter-disclosure]');
    const mobileFilters = matchMedia('(max-width: 900px)');
    const setFilterDisclosure = (event) => { if (filterDisclosure) filterDisclosure.open = !event.matches; };
    setFilterDisclosure(mobileFilters);
    mobileFilters.addEventListener('change', setFilterDisclosure);
    update();
  });
})();
